import { makeStyles } from "tss-react/mui"
import { chipClasses } from "@mui/material"
import { blueGrey } from "../../../mp-core/themes/palette"

type StylesParams = {
  small?: boolean
}

export const useStyles = makeStyles<StylesParams>()(
  ({ spacing }, { small = false }) => ({
    studyPlanGroups: {
      border: `1px solid ${blueGrey[200]}`,
      borderRadius: 3,
      padding: spacing(3, 4, 2)
    },
    hoursChip: {
      color: blueGrey[700],
      backgroundColor: blueGrey[50],
      padding: spacing(1, 3),
      height: "auto",

      ...(small && {
        padding: `2px ${spacing(2)}`
      }),

      [`& > .${chipClasses.label}`]: {
        padding: 0
      }
    },
    sectionItemContainer: {
      padding: spacing(2, 3),
      border: `1px solid ${blueGrey[100]}`,
      borderRadius: "3px",
      display: "flex",
      flexGrow: 1,
      "&:not(:last-child)": {
        marginBottom: spacing(1)
      }
    },
    percentages: {
      fontSize: "0.75rem",
      lineHeight: "0.875rem"
    },
    percentagesContainer: {
      display: "flex",
      alignItems: "center"
    }
  })
)
